import { createSlice } from '@reduxjs/toolkit';

// Hydrate from sessionStorage
const token = sessionStorage.getItem('authToken');
let user = null;
try {
  user = token ? JSON.parse(sessionStorage.getItem('userInfo')) : null;
} catch {
  user = null;
}

const initialState = {
  user: user, // { id, name, username, role, status }
  token: token,
  isAuthenticated: !!token,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      // Persist to sessionStorage
      sessionStorage.setItem('authToken', action.payload.token);
      sessionStorage.setItem('userInfo', JSON.stringify(action.payload.user));
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      sessionStorage.removeItem('authToken');
      sessionStorage.removeItem('userInfo');
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer; 